import React, { useEffect, useState } from 'react';

import cssClasses from '../Dashboard.module.css';
import {
  Box,
  Card,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import CustomAutoComplete from '../../../Subcomponents/CustomAutoComplete';
import { supabase } from '../../../supabaseClient';
import { dismissLoader, presentLoader } from '../../../Services/loader';
import { errorTost } from '../../../Services/Toast';
import DashboardCard from '../../../Subcomponents/DashboardCard/DashboardCard';
import totalTokens from '../../../Assets/Images/Dashboard/totalTokens.svg';
import { Pie } from 'react-chartjs-2';
import User from '../../Icons/User';
import { sortBy, groupBy, maxBy, minBy, eq, uniqBy, uniq, orderBy } from 'lodash';
import TokensVsBookingForSalesManagerDetailsModal from './TokensVsBookingForSalesManagerDetailsModal/TokensVsBookingForSalesManagerDetailsModal';
import WingWiseBookingForSalesManagerDetailsModal from './WingWiseBookingForSalesManagerDetailsModal/WingWiseBookingForSalesManagerDetailsModal';
import { TabContext, TabPanel } from '@mui/lab';
import TabsMenu from '../../../Subcomponents/TabsMenu';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { useParams } from 'react-router-dom';
import { loginWithEmailPass } from '../../../Services/LoginService';
import TokenBookingCard from '../../../Subcomponents/TokenBookingCard/TokenBookingCard';

ChartJS.register(ArcElement, Tooltip, Legend);

function EventsDashboard({ isShowEventDropdown = false }) {
  const params = useParams();
  const eventName = params.eventName;
  const launchName = params.launchName
  console.log("eventName, launchName", eventName, launchName);
  const [selectedTabValue, setSelectedTabValue] = useState('Token');

  const [isLoading, setIsLoading] = useState(false);
  const [eventList, setEventList] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(
    eventName ? eventName : 'All'
  );
  const [selectedLaunch, setSelectedLaunch] = useState({
    label: launchName ? launchName : 'All',
    value: launchName ? launchName : 'All',
  });
  // const [launchId, setLaunchId] = useState(null);
  const [launchList, setlaunchList] = useState([]);

  const [upperCardsCounts, setUpperCardsCounts] = useState(null);

  const [arrToken, setArrToken] = useState([]);
  const [arrBooking, setArrBooking] = useState([]);

  const [firstCheckPointData, setFirstCheckPointData] = useState(null);
  const [secondCheckPointData, setSecondCheckPointData] = useState(null);

  const [
    tokensVsBookingDataForSalesManager,
    setTokensVsBookingDataForSalesManager,
  ] = useState(null);
  const [
    tokensVsBookingDataForSalesManagerForModal,
    setTokensVsBookingDataForSalesManagerForModal,
  ] = useState(null);
  const [tokensVsBookingDataForCpManager, setTokensVsBookingDataForCpManager] =
    useState(null);
  const [
    sourceWiseBookingDataForCpManager,
    setSourceWiseBookingDataForCpManager,
  ] = useState(null);

  const [wingWiseBookingData, setWingWiseBookingData] = useState(null);
  const [wingWiseBookingDataForSalesManagerForModal, setWingWiseBookingDataForSalesManagerForModal] = useState(null);
  const [floorGroupWiseBookingData, setFloorGroupWiseBookingData] = useState(null);
  const [seriesGroupWiseBookingData, setSeriesGroupWiseBookingData] = useState(null);
  //todo get Tokens list
  useEffect(() => {
    const loginAuthUser = localStorage.getItem('user');
    // !check whether user is logged in or not as this events dashboard has a separate link without login
    // ! if not logged in, login through dummy user
    if (loginAuthUser) {
      getEvents();
      if (selectedLaunch?.label !== "All") {
        getLaunchId()
      }
    } else {
      loginWithEmailPass(process.env.REACT_APP_BOOKINGMIS_EMAIL, process.env.REACT_APP_BOOKINGMIS_PASSWORD).then((resp) => {
        getEvents();
        if (selectedLaunch?.label !== "All") {
          getLaunchId()
        }
      }).catch((e) => {
        console.log("Error in login: ", e);
      })
    }
  }, [])

  useEffect(() => {
    if (selectedEvent && eventList?.length && eventList?.length > 0) {
      getLaunchId().then(() => {
        getEventAnalyticsFromServer()
          .then(() => {
            getSalesBookingEventAnalyticsFromServer()
              .then(() => {
                getCpBookingEventAnalyticsFromServer()
                  .then(() => {
                    getSourceWiseBookingEventAnalyticsFromServer()
                      .then(() => {
                        getWingWiseBookingEventAnalyticsFromServer()
                          .then(() => {
                            dismissLoader();
                            setIsLoading(false);
                          })
                          .catch((err) => {
                            dismissLoader();
                            setIsLoading(false);
                          });
                      })
                      .catch((err) => {
                        dismissLoader();
                        setIsLoading(false);
                      });
                  })
                  .catch((err) => {
                    dismissLoader();
                    setIsLoading(false);
                  });
              })
              .catch((err) => {
                dismissLoader();
                setIsLoading(false);
              });
          })
          .catch((err) => {
            dismissLoader();
            setIsLoading(false);
          });
      }).catch((err) => {
        dismissLoader();
        setIsLoading(false);
      })
      selectedEvent !== "All" && getLaunchList();
    }
  }, [selectedEvent, eventList, selectedLaunch]);

  async function getEvents() {
    await supabase.from('Events').select('*').eq("isPublished", true).then(res => {
      console.log("Events res => ", res);
      if (res.data) {
        setEventList([...res.data]);
      }
    })
  }
  async function getLaunchId() {
    await supabase.from("Launches").select("*").eq("title", selectedLaunch?.label).then((res) => {
      // console.log("launches res", res);
      // setLaunchId(res?.data?.[0]?.launchId)
      selectedLaunch.value = res?.data?.[0]?.launchId;
    }).catch((err) => {
      console.log(err);
    })
  }
  const getLaunchList = () => {
    const filterEvent = eventList.filter(val => val?.title === selectedEvent)
    if (selectedLaunch?.label === "All") {
      presentLoader()
      setIsLoading(true)
      supabase.from("Launches").select("*").eq("eventId", filterEvent[0]?.eventId).then((value) => {
        supabase.from("EventTokensLaunchRelations").then((data1) => {

          const payload = []
          value.data?.forEach(v => {
            const selectedLaunch = data1?.data?.find(i => i?.launchId === v?.launchId && i?.eventId === filterEvent[0]?.eventId)

            if (selectedLaunch) {
              payload.push(v)
            }
          })
          setlaunchList(value?.data)
          dismissLoader()
          setIsLoading(false)
        })
      }).catch(err => {
        dismissLoader()
        setIsLoading(false)
        errorTost(err.message)
      })
    }
  }

  async function getEventAnalyticsFromServer() {
    presentLoader();
    setIsLoading(true);

    try {
      let query = supabase.from("EventTokensLaunchRelations").select("*");
      if (selectedLaunch?.label !== "All") {
        query = query.eq("launchId", selectedLaunch?.value);
      }
      let eventTokenLaunchData = await query;

      const eventTokens = eventTokenLaunchData?.data?.filter((launch) => launch?.eventTokenId).map((launch) => launch.eventTokenId);

      let EventTokenLeadRelationsSupabaseQuery = supabase
        .from('EventTokenLeadRelations')
        .select('*, leadId(*), eventTokenId(*, tokenId(*))');
      // let AllotmentPaymentSupabaseQueryForWithoutTokenBooking = supabase.from("AllotmentPayment").select("*");
      // let AllotmentPaymentSupabaseQueryForWithTokenBooking = supabase.from("AllotmentPayment").select("*");
      let AllotmentPaymentSupabaseQuery = supabase
        .from('AllotmentPayment')
        .select('*, paymentId(*, eventTokenId(*, tokenId(*)))');

      if (selectedLaunch?.label !== "All") {
        EventTokenLeadRelationsSupabaseQuery = EventTokenLeadRelationsSupabaseQuery.in("eventTokenId.eventTokenId", eventTokens)

        AllotmentPaymentSupabaseQuery = AllotmentPaymentSupabaseQuery
          .in("paymentId.eventTokenId.eventTokenId", eventTokens)
      }
      if (selectedEvent !== 'All') {
        let _selectedTokenId = eventList.find(
          (f) => f.title === selectedEvent
        )?.eventId;
        if (_selectedTokenId) {
          EventTokenLeadRelationsSupabaseQuery =
            EventTokenLeadRelationsSupabaseQuery.eq(
              'eventId',
              _selectedTokenId
            );
          // AllotmentPaymentSupabaseQueryForWithoutTokenBooking = AllotmentPaymentSupabaseQueryForWithoutTokenBooking.eq("eventId", _selectedTokenId);
          // AllotmentPaymentSupabaseQueryForWithTokenBooking = AllotmentPaymentSupabaseQueryForWithTokenBooking.eq("eventId", _selectedTokenId);
          AllotmentPaymentSupabaseQuery = AllotmentPaymentSupabaseQuery.eq(
            'eventId',
            _selectedTokenId
          );
        }
      }

      if (selectedLaunch?.label !== 'All') {
        if (selectedLaunch) {
          AllotmentPaymentSupabaseQuery = AllotmentPaymentSupabaseQuery.eq(
            'launchId',
            selectedLaunch?.value
          );
        }
      }

      let analysisDataResponse =
        await EventTokenLeadRelationsSupabaseQuery.eq(
          'isPrerequisiteUsed',
          false
        ).or('status.eq.active,status.eq.alloted,status.eq.adjusted');
      // const AllotmentPaymentSupabaseQueryForWithoutTokenBookingResponse = await AllotmentPaymentSupabaseQueryForWithoutTokenBooking.in('pricingType', ['event', 'preselect']).is('paymentId', null);
      // const AllotmentPaymentSupabaseQueryForWithTokenBookingResponse = await AllotmentPaymentSupabaseQueryForWithTokenBooking.in('pricingType', ['event', 'preselect']).not("paymentId", "is", null);
      const AllotmentPaymentSupabaseQueryResponse =
        await AllotmentPaymentSupabaseQuery.in('pricingType', [
          'event',
          'preselect',
        ])
          .neq('status', 'Released')
          .neq('status', 'Cancelled')
          .neq('status', 'On Hold')
          .neq('status', 'Refund Initiated')
          .neq('status', 'Refund Processed')
      // .eq("status", "Payment Complete");
      AllotmentPaymentSupabaseQueryResponse.data =
        AllotmentPaymentSupabaseQueryResponse.data.filter((ele) => {
          if (
            (ele.pricingType === 'preselect' &&
              ele.preselectConfirmation === 'confirmed') || ele.pricingType === 'event'
          ) {
            return true;
          } else {
            return false;
          }
        });
      console.log('analysisDataResponse => ', analysisDataResponse);
      console.log(
        'AllotmentPaymentSupabaseQueryResponse => ',
        AllotmentPaymentSupabaseQueryResponse
      );
      AllotmentPaymentSupabaseQueryResponse.data = AllotmentPaymentSupabaseQueryResponse?.data?.filter((item) => item?.paymentId?.eventTokenId != null);
      // console.log(
      //   'analysisDataResponse => ',
      //   groupBy(
      //     analysisDataResponse.data,
      //     (item) => item?.eventTokenId?.tokenId?.name
      //   )
      // );

      analysisDataResponse.data = analysisDataResponse.data.filter((item) => item?.eventTokenId != null);
      const groupByAnalysisDataResponseData = groupBy(
        analysisDataResponse.data,
        (item) => item?.eventTokenId?.tokenId?.name
      );
      let _arrToken = [
      ];
      let _arrBooking = [
        {
          tokenName: 'Total Tokens',
          tokenCount: analysisDataResponse?.data?.length,
          bookingName: 'Total Bookings',
          bookingCount: AllotmentPaymentSupabaseQueryResponse?.data?.length,
        },
      ];

      for (const _tokenName of Object.keys(groupByAnalysisDataResponseData)) {
        _arrToken.push({
          tokenName: _tokenName,
          tokenCount: groupByAnalysisDataResponseData[_tokenName]?.length || 0,
          bookingName: _tokenName,
          bookingCount:
            AllotmentPaymentSupabaseQueryResponse.data?.filter(
              (item) =>
                item?.paymentId?.eventTokenId?.tokenId?.name === _tokenName
            )?.length || 0,
        });
        // if(AllotmentPaymentSupabaseQueryResponse.data?.filter( item => item?.paymentId?.eventTokenId?.tokenId?.name === _tokenName).filter(f => !f?.eventTokenId?.tokenId?.isPreselect || !f?.eventTokenId?.tokenId?.isPriorityPass).length > 0) {
        //     _arrBooking.push({
        //         name: _tokenName,
        //         count: AllotmentPaymentSupabaseQueryResponse.data?.filter( item => item?.paymentId?.eventTokenId?.tokenId?.name === _tokenName).filter(f => !f?.eventTokenId?.tokenId?.isPreselect || !f?.eventTokenId?.tokenId?.isPriorityPass).filter(f => f?.paymentId?.status === "alloted" || f?.paymentId?.status === "active")?.length || 0
        //     });
        // } else {
        // _arrBooking.push({

        // });
        // }
      }

      console.log({ _arrToken, _arrBooking });
      setArrToken([..._arrToken]);
      setArrBooking([..._arrBooking]);

      console.log(
        'AllotmentPaymentSupabaseQueryResponse => ',
        AllotmentPaymentSupabaseQueryResponse
      );

      if (analysisDataResponse?.data) {
        // const _totalCountCount              = analysisDataResponse?.data?.length;
        // const _preSelectCount               = analysisDataResponse?.data.filter(f => f?.eventTokenId?.tokenId?.isPreselect)?.length;
        // const _priorityPassCount            = analysisDataResponse?.data.filter(f => f?.eventTokenId?.tokenId?.isPriorityPass)?.length;
        // const _generalTokensCount           = analysisDataResponse?.data.filter(f => !f?.eventTokenId?.tokenId?.isPreselect && !f?.eventTokenId?.tokenId?.isPriorityPass)?.length;
        // const _withoutTokenBookingsCount    = AllotmentPaymentSupabaseQueryForWithoutTokenBookingResponse?.data?.length;
        // const _withTokenBookingsCount       = AllotmentPaymentSupabaseQueryForWithTokenBookingResponse?.data?.length;
        // const _totalBookingsCount           = AllotmentPaymentSupabaseQueryForWithoutTokenBookingResponse?.data?.length + AllotmentPaymentSupabaseQueryForWithTokenBookingResponse?.data?.length;

        // setUpperCardsCounts({
        //     totalCountCount: _totalCountCount || 0,
        //     preSelectCount: _preSelectCount || 0,
        //     priorityPassCount: _priorityPassCount || 0,
        //     generalTokensCount: _generalTokensCount || 0,
        //     withoutTokenBookingsCount: _withoutTokenBookingsCount || 0,
        //     withTokenBookingsCount: _withTokenBookingsCount || 0,
        //     totalBookingsCount: _totalBookingsCount || 0,
        // });

        //todo For Check Point [1 and 2] Pie Chart
        const _checkPointOneData = analysisDataResponse?.data.filter(
          (f) => f?.checkpt1
        );
        const _checkPointTwoData = analysisDataResponse?.data.filter(
          (f) => f?.checkpt1 && f?.checkpt2
        );

        const _checkPointOneGroupDataByName = groupBy(
          _checkPointOneData,
          (item) => item?.eventTokenId?.tokenId?.name
        );
        const _checkPointTwoGroupDataByName = groupBy(
          _checkPointTwoData,
          (item) => item?.eventTokenId?.tokenId?.name
        );

        const checkPointOneLabelArray1 = Object.keys(
          _checkPointOneGroupDataByName
        );
        const checkPointTwoLabelArray1 = Object.keys(
          _checkPointTwoGroupDataByName
        );

        const checkPointOneValueArray = checkPointOneLabelArray1.map(
          (m) => _checkPointOneGroupDataByName[m]?.length || 0
        );

        const checkPointOneLabelArray = checkPointOneLabelArray1.map(
          (m) => `${m} (${_checkPointOneGroupDataByName[m]?.length})` || ""
        );

        const checkPointTwoLabelArray = checkPointTwoLabelArray1.map(
          (m) => `${m} (${_checkPointOneGroupDataByName[m]?.length})` || ""
        );


        const checkPointTwoValueArray = checkPointTwoLabelArray1.map(
          (m) => _checkPointTwoGroupDataByName[m]?.length || 0
        );

        console.log({ checkPointOneValueArray, checkPointTwoValueArray });

        // const _preSelectedTokenCountForCheckPointOne = _checkPointOneData.filter(f => f?.eventTokenId?.tokenId?.isPreselect)?.length;
        // const _priorityPassTokenCountForCheckPointOne = _checkPointOneData.filter(f => f?.eventTokenId?.tokenId?.isPriorityPass)?.length || 0;
        // const _otherTokenCountForCheckPointOne = _checkPointOneData.filter(f => !f?.eventTokenId?.tokenId?.isPreselect && !f?.eventTokenId?.tokenId?.isPriorityPass)?.length || 0;

        // const _preSelectedTokenCountForCheckPointTwo = _checkPointTwoData.filter(f => f?.eventTokenId?.tokenId?.isPreselect)?.length || 0;
        // const _priorityPassTokenCountForCheckPointTwo = _checkPointTwoData.filter(f => f?.eventTokenId?.tokenId?.isPriorityPass)?.length || 0;
        // const _otherTokenCountForCheckPointTwo = _checkPointTwoData.filter(f => !f?.eventTokenId?.tokenId?.isPreselect && !f?.eventTokenId?.tokenId?.isPriorityPass)?.length || 0;

        // console.log("[_preSelectedTokenCountForCheckPointOne, _priorityPassTokenCountForCheckPointOne, _otherTokenCountForCheckPointOne] => ", [_preSelectedTokenCountForCheckPointOne, _priorityPassTokenCountForCheckPointOne, _otherTokenCountForCheckPointOne]);
        // console.log("[_preSelectedTokenCountForCheckPointTwo, _priorityPassTokenCountForCheckPointTwo, _otherTokenCountForCheckPointTwo] => ", [_preSelectedTokenCountForCheckPointTwo, _priorityPassTokenCountForCheckPointTwo, _otherTokenCountForCheckPointTwo])
        setFirstCheckPointData({
          labels: checkPointOneLabelArray,
          datasets: [
            {
              label: 'Token Count ',
              data: checkPointOneValueArray,
              backgroundColor: backgroundColor,
              hoverOffset: 4,
            },
          ],
          totalCount: checkPointOneValueArray.reduce((total, num) => total + num, 0)
        });
        setSecondCheckPointData({
          labels: checkPointTwoLabelArray,
          datasets: [
            {
              label: 'Token Count ',
              data: checkPointTwoValueArray,
              backgroundColor: backgroundColor,
              hoverOffset: 4,
            },
          ],
          totalCount: checkPointTwoValueArray.reduce((total, num) => total + num, 0)
        });
      } else {
        throw analysisDataResponse;
      }
      // dismissLoader();
      // setIsLoading(false);
    } catch (error) {
      console.log('analysisDataResponse error => ', error);
      if (error?.error?.message) {
        errorTost(error?.error?.message);
      } else {
        errorTost('Something went wrong! Try again');
      }
      // dismissLoader();
      // setIsLoading(false);
    }
  }
  async function getSalesBookingEventAnalyticsFromServer() {
    presentLoader();
    setIsLoading(true);
    const filterEvent = eventList.filter(val => val?.title === selectedEvent)
    try {
      let query = supabase.from("EventTokensLaunchRelations").select("*");
      if (selectedLaunch?.label !== "All") {
        query = query.eq("launchId", selectedLaunch?.value);
      }
      let eventTokenLaunchData = await query;
      const eventTokens = eventTokenLaunchData?.data?.filter((launch) => launch?.eventTokenId).map((launch) => launch.eventTokenId);

      let EventTokenLeadRelationsSupabaseQuery = supabase
        .from('EventTokenLeadRelations')
        .select('*, leadId(*, userId(*)), eventTokenId(*, tokenId(*))');
      let AllotmentPaymentSupabaseQuery = supabase
        .from('AllotmentPayment')
        .select('*, leadId(*, userId(*)), paymentId(*, eventTokenId(*, tokenId(*)))')

      if (selectedEvent !== 'All') {
        AllotmentPaymentSupabaseQuery = AllotmentPaymentSupabaseQuery.eq("eventId", filterEvent[0]?.eventId)
      }

      if (selectedLaunch?.label !== "All") {
        EventTokenLeadRelationsSupabaseQuery = EventTokenLeadRelationsSupabaseQuery.in("eventTokenId.eventTokenId", eventTokens)

        AllotmentPaymentSupabaseQuery = AllotmentPaymentSupabaseQuery
          .in("paymentId.eventTokenId.eventTokenId", eventTokens)
      }
      if (selectedEvent !== 'All') {
        let _selectedTokenId = eventList.find(
          (f) => f.title === selectedEvent
        )?.eventId;
        if (_selectedTokenId) {
          EventTokenLeadRelationsSupabaseQuery =
            EventTokenLeadRelationsSupabaseQuery.eq(
              'eventId',
              _selectedTokenId
            );
          AllotmentPaymentSupabaseQuery = AllotmentPaymentSupabaseQuery.eq(
            'eventId',
            _selectedTokenId
          );
        }
      }

      if (selectedLaunch?.label !== 'All') {
        if (selectedLaunch) {
          AllotmentPaymentSupabaseQuery = AllotmentPaymentSupabaseQuery.eq(
            'launchId',
            selectedLaunch?.value
          );
        }
      }

      const EventTokenLeadRelationsSupabaseQueryResponse =
        await EventTokenLeadRelationsSupabaseQuery.eq(
          'isPrerequisiteUsed',
          false
        ).or('status.eq.active,status.eq.alloted,status.eq.adjusted');
      // .gt("paidAmount", 0);
      // const AllotmentPaymentSupabaseQueryResponse = await AllotmentPaymentSupabaseQuery.in('pricingType', ['event', 'preselect']).is("paymentId", null);
      const AllotmentPaymentSupabaseQueryResponse =
        await AllotmentPaymentSupabaseQuery.in('pricingType', [
          'event',
          'preselect',
        ])
          .neq('status', 'Released')
          .neq('status', 'Cancelled')
          .neq('status', 'On Hold')
          .neq('status', 'Refund Initiated')
          .neq('status', 'Refund Processed')
      AllotmentPaymentSupabaseQueryResponse.data =
        AllotmentPaymentSupabaseQueryResponse?.data?.filter((ele) => {
          if (
            (ele.pricingType === 'preselect' &&
              ele.preselectConfirmation === 'confirmed') || ele.pricingType === 'event'
          ) {
            return true;
          } else {
            return false;
          }
        });
      console.log(
        'AllotmentPaymentSupabaseQueryResponse => ',
        AllotmentPaymentSupabaseQueryResponse
      );

      if (AllotmentPaymentSupabaseQueryResponse?.data) {
        const filteredG1Data = EventTokenLeadRelationsSupabaseQueryResponse?.data?.filter(
          (allotmentPaymentItem) => allotmentPaymentItem?.leadId !== null && allotmentPaymentItem?.eventTokenId !== null
        );

        const g1 = groupBy(
          filteredG1Data,
          (allotmentPaymentItem) => allotmentPaymentItem?.leadId?.userId?.name
        );

        const filteredG2Data = AllotmentPaymentSupabaseQueryResponse?.data?.filter(
          (allotmentPaymentItem) => allotmentPaymentItem?.leadId !== null && allotmentPaymentItem?.eventTokenId !== null
        );

        const g2 = groupBy(
          filteredG2Data,
          (allotmentPaymentItem) => allotmentPaymentItem?.leadId?.userId?.name
        );

        console.log("g1", g1);
        console.log("g2", g2);

        let objCreate = {};
        Array(...new Set([...Object.keys(g1), ...Object.keys(g2)])).forEach(
          (keyElement) => {
            let arr = [];
            if (g1[keyElement]) {
              arr = [...arr, ...g1[keyElement]];
            }
            if (g2[keyElement]) {
              arr = [...arr, ...g2[keyElement]];
            }
            objCreate[keyElement] = arr;
          }
        );

        console.log("objCreate", objCreate);
        const val = Object.keys(objCreate).reduce((res, cr) => {
          res.push({
            name: cr,
            ar: objCreate[cr],
            tokenArr: objCreate[cr]?.filter((f) => !f.allotmentPaymentId).length
          })
          return res;
        }, [])

        const payload = sortBy(val, (e) => e.tokenArr, ['desc'])
        console.log("payload", payload);
        setTokensVsBookingDataForSalesManager(payload);
      } else {
        throw AllotmentPaymentSupabaseQueryResponse;
      }
      // dismissLoader();
      // setIsLoading(false);
    } catch (error) {
      console.log('analysisDataResponse error => ', error);
      if (error?.error?.message) {
        errorTost(error?.error?.message);
      } else {
        errorTost('Something went wrong! Try again');
      }
      // dismissLoader();
      // setIsLoading(false);
    }
  }
  async function getCpBookingEventAnalyticsFromServer() {
    presentLoader();
    setIsLoading(true);
    const filterEvent = eventList?.filter(val => val?.title === selectedEvent)
    try {
      let query = supabase.from("EventTokensLaunchRelations").select("*");
      if (selectedLaunch?.label !== "All") {
        query = query.eq("launchId", selectedLaunch?.value);
      }
      let eventTokenLaunchData = await query;

      const eventTokens = eventTokenLaunchData?.data?.filter((launch) => launch?.eventTokenId).map((launch) => launch.eventTokenId);

      let EventTokenLeadRelationsSupabaseQuery = supabase
        .from('EventTokenLeadRelations')
        .select('*, leadId(*, cpId(*)), eventTokenId(*, tokenId(*))');
      let AllotmentPaymentSupabaseQuery = supabase
        .from('AllotmentPayment')
        .select('*, leadId(*, cpId(*)), paymentId(*, eventTokenId(*, tokenId(*)))')

      if (selectedEvent !== 'All') {
        AllotmentPaymentSupabaseQuery = AllotmentPaymentSupabaseQuery.eq("eventId", filterEvent[0]?.eventId)
      }

      if (selectedLaunch?.label !== "All") {
        EventTokenLeadRelationsSupabaseQuery = EventTokenLeadRelationsSupabaseQuery.in("eventTokenId.eventTokenId", eventTokens)

        AllotmentPaymentSupabaseQuery = AllotmentPaymentSupabaseQuery
          .in("paymentId.eventTokenId.eventTokenId", eventTokens)
      }
      if (selectedEvent !== 'All') {
        let _selectedTokenId = eventList.find(
          (f) => f.title === selectedEvent
        )?.eventId;
        if (_selectedTokenId) {
          EventTokenLeadRelationsSupabaseQuery =
            EventTokenLeadRelationsSupabaseQuery.eq(
              'eventId',
              _selectedTokenId
            );
          AllotmentPaymentSupabaseQuery = AllotmentPaymentSupabaseQuery.eq(
            'eventId',
            _selectedTokenId
          );
        }
      }

      if (selectedLaunch?.label !== 'All') {
        if (selectedLaunch) {
          AllotmentPaymentSupabaseQuery = AllotmentPaymentSupabaseQuery.eq(
            'launchId',
            selectedLaunch?.value
          );
        }
      }

      const EventTokenLeadRelationsSupabaseQueryResponse =
        await EventTokenLeadRelationsSupabaseQuery.eq(
          'isPrerequisiteUsed',
          false
        )
          .or('status.eq.active,status.eq.alloted,status.eq.adjusted')
          // .gt("paidAmount", 0)
          .not('leadId', 'is', null)
          .not('leadId.cpId', 'is', null);
      const AllotmentPaymentSupabaseQueryResponse =
        await AllotmentPaymentSupabaseQuery.in('pricingType', [
          'event',
          'preselect',
        ])
          .neq('status', 'Released')
          .neq('status', 'Cancelled')
          .neq('status', 'On Hold')
          .neq('status', 'Refund Initiated')
          .neq('status', 'Refund Processed')
          .not('leadId', 'is', null)
          .not('leadId.cpId', 'is', null);
      AllotmentPaymentSupabaseQueryResponse.data =
        AllotmentPaymentSupabaseQueryResponse.data.filter((ele) => {
          if (
            (ele.pricingType === 'preselect' &&
              ele.preselectConfirmation === 'confirmed') || ele.pricingType === 'event'
          ) {
            return true;
          } else {
            return false;
          }
        });
      console.log(
        'AllotmentPaymentSupabaseQueryResponse => ',
        AllotmentPaymentSupabaseQueryResponse
      );

      if (AllotmentPaymentSupabaseQueryResponse?.data) {
        const g1 = groupBy(
          EventTokenLeadRelationsSupabaseQueryResponse?.data?.filter(
            (f) => f?.leadId && f?.eventTokenId !== null
          ),
          (allotmentPaymentItem) =>
            allotmentPaymentItem?.leadId?.cpId?.billingName)
        const g2 = groupBy(
          AllotmentPaymentSupabaseQueryResponse?.data?.filter((f) => f?.leadId && f?.leadId?.cpId && f?.paymentId?.eventTokenId !== null),
          (allotmentPaymentItem) =>
            allotmentPaymentItem?.leadId?.cpId?.billingName
        );

        console.log(g1);
        console.log(g2);

        let objCreate = {};
        Array(...new Set([...Object.keys(g1), ...Object.keys(g2)])).forEach(
          (keyElement) => {
            let arr = [];
            if (g1[keyElement]) {
              arr = [...arr, ...g1[keyElement]];
            }
            if (g2[keyElement]) {
              arr = [...arr, ...g2[keyElement]];
            }
            objCreate[keyElement] = arr;
          }
        );

        console.log("-", objCreate)

        const val = Object.keys(objCreate).reduce((res, cr) => {
          res.push({
            name: cr,
            ar: objCreate[cr],
            tokenArr: objCreate[cr].filter((f) => !f.allotmentPaymentId).length
          })
          return res;
        }, [])

        const payload = sortBy(val, (e) => e.tokenArr, ['desc'])


        console.log('getCpBookingEventAnalyticsFromServer => ', payload);

        setTokensVsBookingDataForCpManager(payload);
      } else {
        throw AllotmentPaymentSupabaseQueryResponse;
      }
      // dismissLoader();
      // setIsLoading(false);
    } catch (error) {
      console.log('analysisDataResponse error => ', error);
      if (error?.error?.message) {
        errorTost(error?.error?.message);
      } else {
        errorTost('Something went wrong! Try again');
      }
      // dismissLoader();
      // setIsLoading(false);
    }
  }
  async function getSourceWiseBookingEventAnalyticsFromServer() {
    presentLoader();
    setIsLoading(true);
    const filterEvent = eventList.filter(val => val?.title === selectedEvent)

    try {
      let query = supabase.from("EventTokensLaunchRelations").select("*");
      if (selectedLaunch?.label !== "All") {
        query = query.eq("launchId", selectedLaunch?.value);
      }
      let eventTokenLaunchData = await query;
      const eventTokens = eventTokenLaunchData?.data?.filter((launch) => launch?.eventTokenId)?.map((launch) => launch.eventTokenId);

      let AllotmentPaymentSupabaseQuery = supabase
        .from('AllotmentPayment')
        .select('*, leadId(*, userId(*)), paymentId(*, eventTokenId(*, tokenId(*))))')
      if (selectedEvent !== 'All') {
        AllotmentPaymentSupabaseQuery = AllotmentPaymentSupabaseQuery.eq("eventId", filterEvent[0]?.eventId)
      }

      if (selectedLaunch?.label !== "All") {
        AllotmentPaymentSupabaseQuery = AllotmentPaymentSupabaseQuery
          .in("paymentId.eventTokenId.eventTokenId", eventTokens)
      }

      if (selectedEvent !== 'All') {
        let _selectedTokenId = eventList.find(
          (f) => f.title === selectedEvent
        )?.eventId;
        if (_selectedTokenId) {
          AllotmentPaymentSupabaseQuery = AllotmentPaymentSupabaseQuery.eq(
            'eventId',
            _selectedTokenId
          );
        }
      }

      if (selectedLaunch?.label !== 'All') {
        if (selectedLaunch) {
          AllotmentPaymentSupabaseQuery = AllotmentPaymentSupabaseQuery.eq(
            'launchId',
            selectedLaunch?.value
          );
        }
      }

      const AllotmentPaymentSupabaseQueryResponse =
        await AllotmentPaymentSupabaseQuery.in('pricingType', [
          'event',
          'preselect',
        ])
          .neq('status', 'Released')
          .neq('status', 'Cancelled')
          .not('leadId', 'is', null)
          .neq('status', 'On Hold')
          .neq('status', 'Refund Initiated')
          .neq('status', 'Refund Processed')
      AllotmentPaymentSupabaseQueryResponse.data =
        AllotmentPaymentSupabaseQueryResponse?.data?.filter((ele) => {
          if (
            (ele.pricingType === 'preselect' &&
              ele.preselectConfirmation === 'confirmed') || ele.pricingType === 'event'
          ) {
            return true;
          } else {
            return false;
          }
        });
      console.log(
        'AllotmentPaymentSupabaseQueryResponse => ',
        AllotmentPaymentSupabaseQueryResponse
      );

      if (AllotmentPaymentSupabaseQueryResponse?.data) {
        const g2 = groupBy(
          AllotmentPaymentSupabaseQueryResponse?.data?.filter((f) => f?.leadId && f?.paymentId?.eventTokenId !== null),
          (allotmentPaymentItem) => allotmentPaymentItem?.leadId?.userId?.name
        );

        // let objCreate = {};
        // Array(...new Set([...Object.keys(g1), ...Object.keys(g2)])).forEach(keyElement => {
        //     let arr = [];

        //     if (g2[keyElement]) {
        //         arr = [...arr, ...g2[keyElement]]
        //     }
        //     objCreate[keyElement] = arr;
        // });

        const orderbySalesName = orderBy(Object.keys(g2))

        const sortedObject = orderbySalesName.reduce((acc, key) => {
          acc[key] = g2[key];
          return acc;
        }, {});
        console.log('objCreate => ', sortedObject);

        console.log('getSourceWiseBookingEventAnalyticsFromServer => ', sortedObject);
        setSourceWiseBookingDataForCpManager(sortedObject);
      } else {
        throw AllotmentPaymentSupabaseQueryResponse;
      }
      // dismissLoader();
      // setIsLoading(false);
    } catch (error) {
      console.log('analysisDataResponse error => ', error);
      if (error?.error?.message) {
        errorTost(error?.error?.message);
      } else {
        errorTost('Something went wrong! Try again');
      }
      // dismissLoader();
      // setIsLoading(false);
    }
  }
  async function getWingWiseBookingEventAnalyticsFromServer() {
    presentLoader();
    setIsLoading(true);

    try {
      let LaunchInventoryRelationsSupabaseQuery = supabase
        .from('LaunchInventoryRelations')
        .select(
          '* , launchId(*) , unitId(*, AllotmentPayment!left(*), ProjectInventoryRelations!left(*),leadId(* , userId(*)), wingId(*), inventoryStatusId(*), inventoryTypeId(*))'
        );

      //, leadId(*, userId(*)), unitId(*, wingId(*), inventoryStatusId(*), inventoryTypeId(*))

      if (selectedEvent !== 'All') {
        let _selectedTokenId = eventList.find(
          (f) => f.title === selectedEvent
        )?.eventId;
        if (_selectedTokenId) {
          LaunchInventoryRelationsSupabaseQuery = LaunchInventoryRelationsSupabaseQuery.eq(
            'launchId.eventId',
            _selectedTokenId
          );
        }
      }

      if (selectedLaunch?.label !== 'All') {
        if (selectedLaunch) {
          LaunchInventoryRelationsSupabaseQuery = LaunchInventoryRelationsSupabaseQuery.eq(
            'launchId',
            selectedLaunch?.value
          );
        }
      }

      // const AllotmentPaymentSupabaseQueryResponse = await AllotmentPaymentSupabaseQuery.in('pricingType', ['event', 'preselect']);
      const AllotmentPaymentSupabaseQueryResponse = await LaunchInventoryRelationsSupabaseQuery;
      console.log(
        'AllotmentPaymentSupabaseQueryResponse111',
        AllotmentPaymentSupabaseQueryResponse
      );

      //.in('pricingType', ['event', 'preselect']).neq('status', 'Released').neq('status', 'Cancelled')
      // AllotmentPaymentSupabaseQueryResponse.data = AllotmentPaymentSupabaseQueryResponse.data.filter((ele) => { if (ele.pricingType === 'preselect' && ele.preselectConfirmation === 'confirmed') { return true } else { return false } })
      // console.log("getWingWiseBookingEventAnalyticsFromServerResponse => ", AllotmentPaymentSupabaseQueryResponse);

      if (AllotmentPaymentSupabaseQueryResponse?.data) {
        AllotmentPaymentSupabaseQueryResponse.data =
          AllotmentPaymentSupabaseQueryResponse.data.filter(
            (ele) =>
              ele.unitId.ProjectInventoryRelations?.length > 0 && ele.launchId
          );
        const uniqByUnitId = uniqBy(
          AllotmentPaymentSupabaseQueryResponse.data,
          (allotmentPaymentItem) => allotmentPaymentItem?.unitId?.unitId
        );
        console.log("uniqByUnitId-->", uniqByUnitId);
        const filteredDataOnAllotment = uniqByUnitId.filter((allotment) => {
          if (allotment?.unitId?.AllotmentPayment?.length > 0) {
            const allotmentData = allotment?.unitId?.AllotmentPayment
              ? allotment.unitId.AllotmentPayment
                .filter(payment => payment.created_at) // Ensure `created_at` exists
                .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)) : null;

            const paymentStatus = allotmentData?.[0]?.status;

            if (
              paymentStatus !== "Released" &&
              paymentStatus !== "Cancelled" &&
              paymentStatus !== "On Hold" &&
              paymentStatus !== "Refund Initiated" &&
              paymentStatus !== "Refund Processed"
            ) {
              if (
                (allotmentData?.[0]?.pricingType === "preselect" &&
                  allotmentData?.[0]?.preselectConfirmation ===
                  "confirmed") || allotmentData?.[0]?.pricingType === "event"
              ) {
                return true;
              }
            }
          } else {
            return true;
          }
          return false;
        });
        const g1 = groupBy(
          filteredDataOnAllotment,
          (allotmentPaymentItem) => allotmentPaymentItem?.unitId?.wingId?.wingId
        );
        setWingWiseBookingData(g1);

        //todo For floor Group Wise Data
        // const s1 = sortBy(AllotmentPaymentSupabaseQueryResponse.data, allotmentPaymentItem => allotmentPaymentItem?.unitId?.floorNo);
        const g2 = groupBy(
          filteredDataOnAllotment,
          (allotmentPaymentItem) => allotmentPaymentItem?.unitId?.floorNo
        );
        let _obj = {
          Lower: {
            arr: [],
          },
          Middle: {
            arr: [],
          },
          Upper: {
            arr: [],
          },
        };

        Object.keys(g2).forEach((elementKey, index) => {
          // if ((index+1) % 3 === 1) {
          //     _obj.Upper.arr = [..._obj.Upper.arr, ...g2[elementKey]]
          // }
          // if ((index+1) % 3 === 2) {
          //     _obj.Middle.arr = [..._obj.Middle.arr, ...g2[elementKey]]
          // }
          // if ((index+1) % 3 === 0) {
          //     _obj.Lower.arr = [..._obj.Lower.arr, ...g2[elementKey]]
          // }

          const convertToNum =
            elementKey.split(' ').filter((ele) => parseInt(ele))?.length > 0
              ? parseInt(
                elementKey.split(' ').filter((ele) => parseInt(ele))[0]
              )
              : 0;
          if (convertToNum <= 4) {
            _obj.Lower.arr = [..._obj.Lower.arr, ...g2[elementKey]];
          } else if (convertToNum <= 18) {
            _obj.Middle.arr = [..._obj.Middle.arr, ...g2[elementKey]];
          } else {
            _obj.Upper.arr = [..._obj.Upper.arr, ...g2[elementKey]];
          }
        });

        _obj.Upper.min = minBy(
          _obj.Upper.arr,
          (allotmentPaymentItem) => allotmentPaymentItem?.unitId?.floorNo
        )?.unitId?.floorNo;
        _obj.Upper.max = maxBy(
          _obj.Upper.arr,
          (allotmentPaymentItem) => allotmentPaymentItem?.unitId?.floorNo
        )?.unitId?.floorNo;

        _obj.Middle.min = minBy(
          _obj.Middle.arr,
          (allotmentPaymentItem) => allotmentPaymentItem?.unitId?.floorNo
        )?.unitId?.floorNo;
        _obj.Middle.max = maxBy(
          _obj.Middle.arr,
          (allotmentPaymentItem) => allotmentPaymentItem?.unitId?.floorNo
        )?.unitId?.floorNo;

        _obj.Lower.min = minBy(
          _obj.Lower.arr,
          (allotmentPaymentItem) => allotmentPaymentItem?.unitId?.floorNo
        )?.unitId?.floorNo;
        _obj.Lower.max = maxBy(
          _obj.Lower.arr,
          (allotmentPaymentItem) => allotmentPaymentItem?.unitId?.floorNo
        )?.unitId?.floorNo;

        // console.log("g2 => ", g2);
        // console.log("_obj => ", _obj);
        setFloorGroupWiseBookingData(_obj);
        // Lower  (1-9)
        // Middle  (10-18)
        // Upper  (19-28) +++++

        //todo For Series Wise Data
        console.log('uniqByUnitId', uniqByUnitId);
        const g3 = groupBy(filteredDataOnAllotment, (allotmentPaymentItem) => {
          const unitNo = allotmentPaymentItem?.unitId?.unitNo;
          let mod;
          if (/\D/.test(unitNo)) {
            const lastTwoDigits = unitNo.slice(-2);
            mod = Number(lastTwoDigits) % 10;
          } else {
            mod = Number(unitNo) % 10;
          }
          let result = mod === 0 ? 10 : mod;
          return result;
        });
        console.log('g3 => ', g3);
        let labels = uniq(
          filteredDataOnAllotment.map((m) => {
            const unitNo = m.unitId.unitNo;
            let mod;
            if (/\D/.test(unitNo)) {
              const lastTwoDigits = unitNo.slice(-2);
              mod = Number(lastTwoDigits) % 10;
            } else {
              mod = Number(unitNo) % 10;
            }
            return mod === 0 ? 10 : mod;
          })
        ).sort((a, b) => a - b);
        console.log('labels', labels);
        let _objForSeries = {};
        for (const ele of labels) {
          _objForSeries = {
            ..._objForSeries,
            [ele]: g3[ele]?.length > 0 ? g3[ele] : [],
          };
        }
        console.log(_objForSeries);
        // let _objForSeries = {
        //   '01': g3['01']?.length > 0 ? g3['01'] : [],
        //   '02': g3['02']?.length > 0 ? g3['02'] : [],
        //   '03': g3['03']?.length > 0 ? g3['03'] : [],
        //   '04': g3['04']?.length > 0 ? g3['04'] : [],
        // };

        // setSeriesGroupWiseBookingData(g3)

        setSeriesGroupWiseBookingData(_objForSeries);
      } else {
        throw AllotmentPaymentSupabaseQueryResponse;
      }
      // dismissLoader();
      // setIsLoading(false);
    } catch (error) {
      console.error('analysisDataResponse error => ', error);
      if (error?.error?.message) {
        errorTost(error?.error?.message);
      } else {
        errorTost('Something went wrong! Try again');
      }
      // dismissLoader();
      // setIsLoading(false);
    }
  }

  return (
    <>
      <div>
        <Box className={cssClasses.TabsWrapper} style={{ height: "100%" }}>
          <TabContext value={selectedTabValue}>
            <div className={cssClasses.dropDownWrapper}>
              <TabsMenu
                selectedColor={"#1570EF"}
                selectedBackgroundColor={"#FFFFFF"}
                stylesForTab={{
                  color: "#344054",
                  fontSize: "1.6rem",
                  fontStyle: "normal",
                  fontWeight: "500",
                  lineHeight: "2.4rem",
                  padding: "0.8rem 1.2rem",
                  textTransform: "unset",
                  borderBottom: "1px solid #EAECF0",
                }}
                borderColor={"#1570EFs"}
                stylesForWrapper={{
                  padding: "1.5rem 0",
                  background: "#FFFFFF",
                }}
                list={tabList}
                value={selectedTabValue}
                handleChange={(e, value) => {
                  setSelectedTabValue(value);
                }}
              />
              <Box>
                {isShowEventDropdown && (
                  <div
                    style={{
                      display: "flex",
                      // alignItems: 'baseline',
                      // gap: '5rem',
                      // flex: 1
                      // padding:"0rem 4rem",
                    }}
                  >
                    {/* <p className={cssClasses.button} onClick={() => { }}>Back</p> */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "2rem",
                        width: "100%",
                      }}
                    >
                      <p style={{ fontSize: "2rem" }}>Events&nbsp;:</p>
                      <div style={{ width: "25rem" }}>
                        <CustomAutoComplete
                          NoOptionsText={"No events found"}
                          InitialValue={(e) => {
                            setSelectedEvent(e || "All");
                            setSelectedLaunch({
                              label: "All",
                              value: "All"
                            });
                          }}
                          list={["All", ...eventList.map((m) => m?.title)]}
                          multiple={false}
                          disable={false}
                          value={selectedEvent}
                        />
                      </div>
                    </div>
                  </div>
                )}
                {(selectedEvent !== "All" && !launchName) && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "2rem",
                      width: "100%",
                    }}
                  >
                    <p style={{ fontSize: "2rem" }}>Launches&nbsp;:</p>
                    <div style={{ width: "23rem" }}>
                      <CustomAutoComplete
                        NoOptionsText={"No launch found"}
                        InitialValue={(e) => {
                          setSelectedLaunch({
                            label: e?.label || "All",
                            value: e?.value || "All",
                          });
                        }}
                        list={
                          launchList
                            ? [
                              { label: "All", value: "All" },
                              ...launchList.map((m) => ({
                                label: m?.title,
                                value: m?.launchId,
                              })),
                            ]
                            : []
                        }
                        multiple={false}
                        disable={false}
                        value={selectedLaunch}
                      />
                    </div>
                  </div>
                )}
                {/* <p style={{ marginTop: '2rem', fontSize: "2rem" }} className={cssClasses.totalCountsHeader}>Total: {totalTokensCount}</p> */}
              </Box>
            </div>

            <TabPanel
              style={{
                height: "calc(100% - 10rem)",
                padding: "0rem !important",
              }}
              className={cssClasses.Tabs}
              value={"Token"}
              index={0}
            >
              <div className={cssClasses.totalCountsDiv}>
                {/* <Grid container spacing={{ xs: 2, md: 3, lg: 3 }} columns={{ xs: 8, sm: 12, md: 12, lg: 20 }}>
                                    <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                        <DashboardCard icon={totalTokens} number={upperCardsCounts?.totalCountCount} title={"Total Tokens"} />
                                    </Grid>
                                    <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                        <DashboardCard icon={totalTokens} number={upperCardsCounts?.preSelectCount} title={"Pre-select"} />
                                    </Grid>
                                    <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                        <DashboardCard icon={totalTokens} number={upperCardsCounts?.priorityPassCount} title={"Priority Pass"} />
                           
                                        </Grid>
                                    <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                        <DashboardCard icon={totalTokens} number={upperCardsCounts?.generalTokensCount} title={"General Tokens"} />
                                    </Grid>
                                    <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                        <DashboardCard icon={totalTokens} number={upperCardsCounts?.withoutTokenBookingsCount} title={"Without Token Bookings"} />
                                    </Grid>
                                    <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                        <DashboardCard icon={totalTokens} number={upperCardsCounts?.withTokenBookingsCount} title={"With Token Bookings"} />
                                    </Grid>
                                    <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                        <DashboardCard icon={totalTokens} number={upperCardsCounts?.totalBookingsCount} title={"Total Bookings"} />
                                    </Grid>
                                </Grid> */}
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <p
                    style={{ marginTop: "2rem" }}
                    className={cssClasses.countsHeader}
                  >
                    Tokens
                  </p>
                  <p style={{ marginTop: "2rem" }}
                    className={cssClasses.countsHeader}>({`Total Tokens: ${arrBooking?.[0]?.tokenCount ? arrBooking?.[0]?.tokenCount : 0} :: Tokens Booked: ${arrBooking?.[0]?.bookingCount ? arrBooking?.[0]?.bookingCount : 0}`})</p>
                </div>
                <Grid
                  container
                  spacing={{ xs: 2, md: 3, lg: 3 }}
                  columns={{ xs: 4, sm: 12, md: 12, lg: 20 }}
                >
                  {
                    // arrToken &&
                    //   arrToken?.length > 0 &&
                    orderBy(
                      arrToken,
                      [(token) => token.tokenName.toLowerCase()],
                      ["asc"]
                    ).map((arrTokenItem) => (
                      <Grid
                        key={arrTokenItem?.tokenName}
                        className={cssClasses.Grid}
                        item
                        xs={4}
                        sm={4}
                        md={4}
                        lg={4}
                      >
                        <TokenBookingCard
                          icon={totalTokens}
                          tokenNumber={arrTokenItem?.tokenCount}
                          tokenTitle={arrTokenItem?.tokenName}
                          bookingNumber={arrTokenItem?.bookingCount}
                        />
                      </Grid>
                    ))}
                </Grid>

                {/* <p
                  style={{ marginTop: "2rem" }}
                  className={cssClasses.countsHeader}
                >
                  Bookings
                </p>
                <Grid
                  container
                  spacing={{ xs: 2, md: 3, lg: 3 }}
                  columns={{ xs: 8, sm: 12, md: 12, lg: 20 }}
                >
                  {arrBooking &&
                    arrBooking?.length > 0 &&
                    orderBy(
                      arrBooking,
                      [(token) => token.name.toLowerCase()],
                      ["asc"]
                    ).map((arrTokeBooking) => (
                      <Grid
                        key={arrTokeBooking?.name}
                        className={cssClasses.Grid}
                        item
                        xs={4}
                        sm={4}
                        md={4}
                        lg={4}
                      >
                        <DashboardCard
                          icon={totalTokens}
                          number={arrTokeBooking?.count}
                          title={arrTokeBooking?.name}
                        />
                      </Grid>
                    ))}
                </Grid> */}

                <Divider style={{ margin: "3rem 0" }} />

                <Box className={cssClasses.bookingTableCardWrapper}>
                  <Card
                    style={{ padding: "2.4rem" }}
                    className={cssClasses.cardCss}
                  >
                    <div className={cssClasses.cardHeader}>
                      <User color={"#FFFF"} fill={"#1570EF"} />
                      <p>Tokens Vs Booking (sales Manager)</p>
                    </div>
                    <TableContainer>
                      {/* <Table sx={{ minWidth: 650 }} aria-label="simple table"> */}
                      <Table stickyHeader sx={[tableStyle]}>
                        <TableHead>
                          <TableRow>
                            <TableCell>Sales&nbsp;Manager</TableCell>
                            <TableCell align="right">Token</TableCell>
                            <TableCell align="right">Booking</TableCell>
                            <TableCell align="right">
                              Total&nbsp;Sales
                            </TableCell>
                            <TableCell align="right">
                              Action&nbsp;&nbsp;
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {tokensVsBookingDataForSalesManager &&
                            Object.keys(tokensVsBookingDataForSalesManager)
                              .reverse()
                              .map((salesNameKey) => (
                                <TableRow
                                  key={salesNameKey}
                                  sx={{
                                    "&:last-child td, &:last-child th": {
                                      border: 0,
                                    },
                                  }}
                                >
                                  <TableCell component="th" scope="row">
                                    {
                                      tokensVsBookingDataForSalesManager[
                                        salesNameKey
                                      ]?.name
                                    }
                                  </TableCell>
                                  <TableCell align="right">
                                    {tokensVsBookingDataForSalesManager[
                                      salesNameKey
                                    ]?.ar.filter((f) => !f?.allotmentPaymentId)
                                      ?.length || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    {tokensVsBookingDataForSalesManager[
                                      salesNameKey
                                    ]?.ar.filter((f) => f?.allotmentPaymentId)
                                      ?.length || 0}
                                  </TableCell>
                                  <TableCell align="right" width={"15rem"}>
                                    ₹{" "}
                                    {numDifferentiation(
                                      tokensVsBookingDataForSalesManager[
                                        salesNameKey
                                      ]?.ar
                                        .filter((f) => f?.allotmentPaymentId)
                                        ?.map((item) => item?.unitCost?.bsp)
                                        ?.reduce(
                                          (prev, next) => prev + next,
                                          0
                                        ) || 0
                                    )}
                                  </TableCell>
                                  <TableCell align="right">
                                    <Typography
                                      color={"#1570EF"}
                                      fontSize={"1.6rem"}
                                      textAlign={"right"}
                                      style={{ cursor: "pointer" }}
                                      width={"10rem"}
                                      onClick={() => {
                                        setTokensVsBookingDataForSalesManagerForModal(
                                          tokensVsBookingDataForSalesManager[
                                            salesNameKey
                                          ].ar
                                        );
                                      }}
                                    >
                                      View Details
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Card>
                  <Card
                    style={{ padding: "2.4rem" }}
                    className={cssClasses.cardCss}
                  >
                    <div className={cssClasses.cardHeader}>
                      <User color={"#FFFF"} fill={"#1570EF"} />
                      <p>Tokens VS Booking (CP)</p>
                    </div>
                    <TableContainer>
                      {/* <Table sx={{ minWidth: 650 }} aria-label="simple table"> */}
                      <Table stickyHeader sx={[tableStyle]}>
                        <TableHead>
                          <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell align="right">Token</TableCell>
                            <TableCell align="right">Booking</TableCell>
                            <TableCell align="right" width={"15rem"}>
                              Total&nbsp;Sales
                            </TableCell>
                            {/* <TableCell align="right">Action</TableCell> */}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {tokensVsBookingDataForCpManager &&
                            Object.keys(tokensVsBookingDataForCpManager)
                              .reverse()
                              .map((salesNameKey) => (
                                <TableRow
                                  key={salesNameKey}
                                  sx={{
                                    "&:last-child td, &:last-child th": {
                                      border: 0,
                                    },
                                  }}
                                >
                                  <TableCell component="th" scope="row">
                                    {
                                      tokensVsBookingDataForCpManager[
                                        salesNameKey
                                      ]?.name
                                    }
                                  </TableCell>
                                  <TableCell align="right">
                                    {tokensVsBookingDataForCpManager[
                                      salesNameKey
                                    ]?.ar.filter((f) => !f?.allotmentPaymentId)
                                      ?.length || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    {tokensVsBookingDataForCpManager[
                                      salesNameKey
                                    ]?.ar.filter((f) => f?.allotmentPaymentId)
                                      ?.length || 0}
                                  </TableCell>
                                  <TableCell align="right" width={"15rem"}>
                                    ₹{" "}
                                    {numDifferentiation(
                                      tokensVsBookingDataForCpManager[
                                        salesNameKey
                                      ]?.ar
                                        .filter((f) => f?.allotmentPaymentId)
                                        ?.map((item) => item?.unitCost?.bsp)
                                        ?.reduce(
                                          (prev, next) => prev + next,
                                          0
                                        ) || 0
                                    )}
                                  </TableCell>
                                  {/* <TableCell align="right"><Typography color={"#374151"} fontSize={"1.6rem"} lineHeight={"3rem"} fontWeight={700} textAlign={"center"} style={{cursor: "pointer"}} component={"u"}>View&nbsp;Details</Typography></TableCell> */}
                                </TableRow>
                              ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Card>
                  <Card
                    style={{ padding: "2.4rem" }}
                    className={cssClasses.cardCss}
                  >
                    <div className={cssClasses.cardHeader}>
                      <User color={"#FFFF"} fill={"#1570EF"} />
                      <p>Source Wise Booking</p>
                    </div>
                    <TableContainer>
                      <Table stickyHeader sx={[tableStyle]}>
                        <TableHead>
                          <TableRow>
                            <TableCell>Sales&nbsp;Manager</TableCell>
                            <TableCell align="right">CP</TableCell>
                            <TableCell align="right">Walk In</TableCell>
                            <TableCell align="right">R & L</TableCell>
                            <TableCell align="right">Total Booking</TableCell>
                            <TableCell align="right">Total Sales</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {sourceWiseBookingDataForCpManager &&
                            Object.keys(sourceWiseBookingDataForCpManager).map(
                              (salesNameKey) => (
                                <TableRow
                                  key={salesNameKey}
                                  sx={{
                                    "&:last-child td, &:last-child th": {
                                      border: 0,
                                    },
                                  }}
                                >
                                  <TableCell component="th" scope="row">
                                    {salesNameKey}
                                  </TableCell>
                                  <TableCell align="right">
                                    {sourceWiseBookingDataForCpManager[
                                      salesNameKey
                                    ]?.filter(
                                      (f) => f?.leadId?.leadType === "CP"
                                    )?.length || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    {sourceWiseBookingDataForCpManager[
                                      salesNameKey
                                    ]?.filter(
                                      (f) => f?.leadId?.leadType === "Direct"
                                    )?.length || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    {sourceWiseBookingDataForCpManager[
                                      salesNameKey
                                    ]?.filter(
                                      (f) => f?.leadId?.leadType === "R&L"
                                    )?.length || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    {(sourceWiseBookingDataForCpManager[
                                      salesNameKey
                                    ]?.filter(
                                      (f) => f?.leadId?.leadType === "CP"
                                    )?.length || 0) +
                                      (sourceWiseBookingDataForCpManager[
                                        salesNameKey
                                      ]?.filter(
                                        (f) => f?.leadId?.leadType === "Direct"
                                      )?.length || 0) +
                                      (sourceWiseBookingDataForCpManager[
                                        salesNameKey
                                      ]?.filter(
                                        (f) => f?.leadId?.leadType === "R&L"
                                      )?.length || 0)}
                                  </TableCell>
                                  <TableCell align="right">
                                    ₹{" "}
                                    {numDifferentiation(
                                      sourceWiseBookingDataForCpManager[
                                        salesNameKey
                                      ]
                                        ?.filter((f) => f?.allotmentPaymentId)
                                        ?.map((item) => item?.unitCost?.bsp)
                                        ?.reduce(
                                          (prev, next) => prev + next,
                                          0
                                        ) || 0
                                    )}
                                  </TableCell>
                                  {/* <TableCell align="right"><Typography color={"#374151"} fontSize={"1.6rem"} lineHeight={"3rem"} fontWeight={700} textAlign={"center"} style={{cursor: "pointer"}} component={"u"}>View&nbsp;Details</Typography></TableCell> */}
                                </TableRow>
                              )
                            )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Card>

                  <Card
                    style={{ padding: "2.4rem" }}
                    className={cssClasses.cardCss}
                  >
                    <div className={cssClasses.cardHeader}>
                      <User color={"#FFFF"} fill={"#1570EF"} />
                      <p>Wing Wise Data</p>
                    </div>
                    <TableContainer>
                      {/* <Table sx={{ minWidth: 650 }} aria-label="simple table"> */}
                      <Table stickyHeader sx={[tableStyle]}>
                        <TableHead>
                          <TableRow>
                            <TableCell>Wing</TableCell>
                            <TableCell align="right">Available</TableCell>
                            <TableCell align="right">Sold</TableCell>
                            <TableCell align="right">Total Sales</TableCell>
                            <TableCell align="right">Action</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {wingWiseBookingData &&
                            Object.keys(wingWiseBookingData).map(
                              (wingNameKey) => (
                                <TableRow
                                  key={wingNameKey}
                                  sx={{
                                    "&:last-child td, &:last-child th": {
                                      border: 0,
                                    },
                                  }}
                                >
                                  {/* {console.log("Object.keys(wingWiseBookingData)" , wingWiseBookingData[wingNameKey])} */}
                                  <TableCell component="th" scope="row">
                                    {
                                      wingWiseBookingData[wingNameKey][0]
                                        ?.unitId?.wingId?.wingName
                                    }
                                  </TableCell>
                                  <TableCell align="right">
                                    {wingWiseBookingData[wingNameKey]?.filter(
                                      (f) =>
                                        ["On Hold", "Available"].some(
                                          (s) =>
                                            s ===
                                            f?.unitId?.inventoryStatusId?.status
                                        )
                                    )?.length || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    {wingWiseBookingData[wingNameKey]?.filter(
                                      (f) =>
                                        [
                                          // "On Hold",
                                          // "Preselected",
                                          "Sold",
                                          "Payment Pending",
                                          "Kyc Pending",
                                          "Kyc Done",
                                        ].some(
                                          (s) =>
                                            s ===
                                            f?.unitId?.inventoryStatusId?.status
                                        )
                                    )?.length || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    ₹{" "}
                                    {numDifferentiation(
                                      wingWiseBookingData[wingNameKey]
                                        ?.filter((f) =>
                                          [
                                            // "On Hold",
                                            // "Preselected",
                                            "Sold",
                                            "Payment Pending",
                                            "Kyc Pending",
                                            "Kyc Done",
                                          ].some(
                                            (s) =>
                                              s ===
                                              f?.unitId?.inventoryStatusId
                                                ?.status
                                          )
                                        )
                                        ?.map((item) => item?.unitId?.BSP)
                                        ?.reduce((prev, next) => prev + next, 0)
                                    ) || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    <Typography
                                      color={"#1570EF"}
                                      fontSize={"1.6rem"}
                                      textAlign={"right"}
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setWingWiseBookingDataForSalesManagerForModal(
                                          wingWiseBookingData[wingNameKey]
                                        );
                                      }}
                                    >
                                      View Details
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              )
                            )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Card>
                  <Card
                    style={{ padding: "2.4rem" }}
                    className={cssClasses.cardCss}
                  >
                    <div className={cssClasses.cardHeader}>
                      <User color={"#FFFF"} fill={"#1570EF"} />
                      <p>Group wise Data</p>
                    </div>
                    <TableContainer>
                      {/* <Table sx={{ minWidth: 650 }} aria-label="simple table"> */}
                      <Table stickyHeader sx={[tableStyle]}>
                        <TableHead>
                          <TableRow>
                            <TableCell>Category</TableCell>
                            <TableCell align="right">Available</TableCell>
                            <TableCell align="right">Sold</TableCell>
                            <TableCell align="right">Total Sales</TableCell>
                            {/* <TableCell align="right">Action</TableCell> */}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {floorGroupWiseBookingData &&
                            Object.keys(floorGroupWiseBookingData).map(
                              (floorNameKey) => (
                                <TableRow
                                  key={floorNameKey}
                                  sx={{
                                    "&:last-child td, &:last-child th": {
                                      border: 0,
                                    },
                                  }}
                                >
                                  <TableCell component="th" scope="row">
                                    {floorNameKey}
                                  </TableCell>
                                  <TableCell align="right">
                                    {floorGroupWiseBookingData[
                                      floorNameKey
                                    ]?.arr?.filter((f) =>
                                      ["On Hold", "Available"].some(
                                        (s) =>
                                          s ===
                                          f?.unitId?.inventoryStatusId?.status
                                      )
                                    )?.length || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    {floorGroupWiseBookingData[
                                      floorNameKey
                                    ]?.arr?.filter((f) =>
                                      [
                                        // "On Hold",
                                        // "Preselected",
                                        "Sold",
                                        "Payment Pending",
                                        "Kyc Pending",
                                        "Kyc Done",
                                      ].some(
                                        (s) =>
                                          s ===
                                          f?.unitId?.inventoryStatusId?.status
                                      )
                                    )?.length || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    ₹{" "}
                                    {numDifferentiation(
                                      floorGroupWiseBookingData[
                                        floorNameKey
                                      ]?.arr
                                        ?.filter((f) =>
                                          [
                                            // "On Hold",
                                            // "Preselected",
                                            "Sold",
                                            "Payment Pending",
                                            "Kyc Pending",
                                            "Kyc Done",
                                          ].some(
                                            (s) =>
                                              s ===
                                              f?.unitId?.inventoryStatusId
                                                ?.status
                                          )
                                        )
                                        ?.map((item) => item?.unitId?.BSP)
                                        ?.reduce(
                                          (prev, next) => prev + next,
                                          0
                                        ) || 0
                                    )}
                                  </TableCell>
                                  {/* <TableCell align='right'>
                                    <Typography
                                      color={'#1570EF'}
                                      fontSize={'1.6rem'}
                                      textAlign={'right'}
                                      style={{ cursor: 'pointer' }}
                                      width={'10rem'}
                                      onClick={() => {
                                        setTokensVsBookingDataForSalesManagerForModal(
                                          tokensVsBookingDataForSalesManager[
                                            salesNameKey
                                          ]
                                        );
                                      }}
                                    >
                                      View Details
                                    </Typography>
                                  </TableCell> */}
                                </TableRow>
                              )
                            )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Card>
                  <Card
                    style={{ padding: "2.4rem" }}
                    className={cssClasses.cardCss}
                  >
                    <div className={cssClasses.cardHeader}>
                      <User color={"#FFFF"} fill={"#1570EF"} />
                      <p>Series wise Data</p>
                    </div>
                    <TableContainer>
                      {/* <Table sx={{ minWidth: 650 }} aria-label="simple table"> */}
                      <Table stickyHeader sx={[tableStyle]}>
                        <TableHead>
                          <TableRow>
                            <TableCell>Series</TableCell>
                            <TableCell align="right">Available</TableCell>
                            <TableCell align="right">Sold</TableCell>
                            <TableCell align="right">Total Sales</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {seriesGroupWiseBookingData &&
                            Object.keys(seriesGroupWiseBookingData)
                              .sort((a, b) => a - b)
                              .map((seriesNameKey) => (
                                <TableRow
                                  key={seriesNameKey}
                                  sx={{
                                    "&:last-child td, &:last-child th": {
                                      border: 0,
                                    },
                                  }}
                                >
                                  <TableCell component="th" scope="row">
                                    #{seriesNameKey}
                                  </TableCell>
                                  <TableCell align="right">
                                    {seriesGroupWiseBookingData[
                                      seriesNameKey
                                    ]?.filter((f) =>
                                      ["On Hold", "Available"].some(
                                        (s) =>
                                          s ===
                                          f?.unitId?.inventoryStatusId?.status
                                      )
                                    )?.length || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    {seriesGroupWiseBookingData[
                                      seriesNameKey
                                    ]?.filter((f) =>
                                      [
                                        // "On Hold",
                                        // "Preselected",
                                        "Sold",
                                        "Payment Pending",
                                        "Kyc Pending",
                                        "Kyc Done",
                                      ].some(
                                        (s) =>
                                          s ===
                                          f?.unitId?.inventoryStatusId?.status
                                      )
                                    )?.length || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    ₹{" "}
                                    {numDifferentiation(
                                      seriesGroupWiseBookingData[seriesNameKey]
                                        ?.filter((f) =>
                                          [
                                            // "On Hold",
                                            // "Preselected",
                                            "Sold",
                                            "Payment Pending",
                                            "Kyc Pending",
                                            "Kyc Done",
                                          ].some(
                                            (s) =>
                                              s ===
                                              f?.unitId?.inventoryStatusId
                                                ?.status
                                          )
                                        )
                                        ?.map((item) => item?.unitId?.BSP)
                                        ?.reduce(
                                          (prev, next) => prev + next,
                                          0
                                        ) || 0
                                    )}
                                  </TableCell>
                                </TableRow>
                              ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Card>
                </Box>
              </div>
            </TabPanel>
            <TabPanel
              style={{
                height: "calc(100% - 10rem)",
                padding: "0rem !important",
              }}
              className={cssClasses.Tabs}
              value={"Attendance"}
              index={1}
            >
              <div className={cssClasses.totalCountsDiv}>
                <Box className={cssClasses.checkPointCardWrapper}>
                  {firstCheckPointData && (
                    <Card>
                      <Typography
                        color={"#374151"}
                        fontSize={"2.4rem"}
                        lineHeight={"3rem"}
                        fontWeight={700}
                        mb={"2rem"}
                        textAlign={"center"}
                      >
                        First Checkpoint - {firstCheckPointData?.totalCount}
                      </Typography>
                      {firstCheckPointData && (
                        <Box className={cssClasses.pieChatContainer}>
                          <Pie
                            data={firstCheckPointData}
                            options={{
                              responsive: true,
                              plugins: {
                                legend: {
                                  position: "right",
                                },
                              },
                            }}
                          />
                        </Box>
                      )}
                    </Card>
                  )}
                  {secondCheckPointData && (
                    <Card>
                      <Typography
                        color={"#374151"}
                        fontSize={"2.4rem"}
                        lineHeight={"3rem"}
                        fontWeight={700}
                        mb={"2rem"}
                        textAlign={"center"}
                      >
                        Second Checkpoint - {secondCheckPointData?.totalCount}
                      </Typography>
                      {secondCheckPointData && (
                        <Box className={cssClasses.pieChatContainer}>
                          <Pie
                            data={secondCheckPointData}
                            options={{
                              responsive: true,
                              plugins: {
                                legend: {
                                  position: "right",
                                },
                              },
                            }}
                          />
                        </Box>
                      )}
                    </Card>
                  )}
                </Box>
                <Divider style={{ margin: "3rem 0" }} />
                <Box >
                  <Card
                    style={{ padding: "2.4rem" }}
                    className={cssClasses.cardCss}
                  >
                    <div className={cssClasses.cardHeader}>
                      <User color={"#FFFF"} fill={"#1570EF"} />
                      <p>Tokens (Sales Manager)</p>
                    </div>
                    <TableContainer>
                      {/* <Table sx={{ minWidth: 650 }} aria-label="simple table"> */}
                      <Table stickyHeader sx={[tableStyle]}>
                        <TableHead>
                          <TableRow>
                            <TableCell>Sales&nbsp;Manager</TableCell>
                            <TableCell align="right" className={cssClasses.headingFont}>Total Count</TableCell>
                            <TableCell align="right" className={cssClasses.headingFont}>Check Point 1</TableCell>
                            <TableCell align="right" className={cssClasses.headingFont}>Check Point 2</TableCell>
                            {/* <TableCell align="right">Total Bookings</TableCell> */}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {tokensVsBookingDataForSalesManager &&
                            Object.keys(tokensVsBookingDataForSalesManager)
                              .reverse()
                              .map((salesNameKey) => (
                                <TableRow
                                  key={salesNameKey}
                                  sx={{
                                    "&:last-child td, &:last-child th": {
                                      border: 0,
                                    },
                                  }}
                                >
                                  <TableCell component="th" scope="row">
                                    {
                                      tokensVsBookingDataForSalesManager[
                                        salesNameKey
                                      ]?.name
                                    }
                                  </TableCell>
                                  <TableCell align="right">
                                    {tokensVsBookingDataForSalesManager[
                                      salesNameKey
                                    ]?.ar.filter((f) => !f?.allotmentPaymentId)
                                      ?.length || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    {tokensVsBookingDataForSalesManager[
                                      salesNameKey
                                    ]?.ar.filter((f) => f?.checkpt1 === true && f?.checkpt2 === false)
                                      ?.length || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    {tokensVsBookingDataForSalesManager[
                                      salesNameKey
                                    ]?.ar.filter((f) => f?.checkpt2 === true)
                                      ?.length || 0}
                                  </TableCell>
                                  {/* <TableCell align="right">
                                    {tokensVsBookingDataForSalesManager[
                                      salesNameKey
                                    ]?.ar.filter((f) => f?.allotmentPaymentId)
                                      ?.length || 0}
                                  </TableCell> */}
                                </TableRow>
                              ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Card>
                </Box>
              </div>
            </TabPanel>
          </TabContext>
        </Box>
      </div>

      {tokensVsBookingDataForSalesManagerForModal && (
        <TokensVsBookingForSalesManagerDetailsModal
          open={true}
          handleClose={() => {
            setTokensVsBookingDataForSalesManagerForModal(null);
          }}
          tokensVsBookingDataForSalesManagerForModal={
            tokensVsBookingDataForSalesManagerForModal
          }
        />
      )}

      {wingWiseBookingDataForSalesManagerForModal && (
        <WingWiseBookingForSalesManagerDetailsModal
          open={true}
          handleClose={() => {
            setWingWiseBookingDataForSalesManagerForModal(null);
          }}
          wingWiseBookingDataForSalesManagerForModal={
            wingWiseBookingDataForSalesManagerForModal
          }
        />
      )}
    </>
  );
}

export default EventsDashboard;

const tableStyle = {
  ' .MuiTableCell-root': {
    fontSize: '1.6rem',
  },
};

const tabList = [
  {
    text: 'Tokens & Bookings',
    value: 'Token',
    key: 0,
  },
  {
    text: 'Attendance',
    value: 'Attendance',
    key: 1,
  },
];
const backgroundColor = [
  'rgb(255, 99, 132)',
  'rgb(54, 162, 235)',
  'rgb(255, 205, 86)',
  'rgb(192,192,192)',
  'rgb(128,0,0)',
  'rgb(0,139,139)',
  'rgb(153,50,204)',
  'rgb(47,79,79)',
  'rgb(178,34,34)',
  'rgb(205,92,92)',
  'rgb(240,230,140)',
  'rgb(240,128,128)',
  'rgb(32,178,170)',
  'rgb(64,224,208)',
  'rgb(154,205,50)',
];
function numDifferentiation(value) {
  const val = Math.abs(value);
  if (val >= 10000000) return `${(value / 10000000).toFixed(2)} Cr`;
  if (val >= 100000) return `${(value / 100000).toFixed(2)} Lac`;
  return value;
}
